import styled from 'styled-components'
import { GRAYSCALE_150, GRAYSCALE_500, GRAYSCALE_600, GRADIENT_SELECTED_OVERLAY, NEUTRAL_100 } from '../../styles/colors'
import { GIVONIC, INTER } from '../../styles/fonts'

export const Container = styled.div`
  background: ${GRADIENT_SELECTED_OVERLAY};
  border-radius: 12px;
  border: 1px solid ${NEUTRAL_100};
  overflow: hidden;
`

export const TopSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px;
  gap: 8px;
`

export const ProviderRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const Title = styled.span`
  font-family: ${GIVONIC.semiBold};
  font-size: 14px;
  font-weight: 600;
  color: ${GRAYSCALE_600};
`

export const Description = styled.span`
  font-family: ${INTER.regular};
  font-size: 12px;
  font-weight: 400;
  color: ${GRAYSCALE_500};
`

export const BottomSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: ${GRAYSCALE_150};
  padding: 12px;
`
